import { Close, DirectionsBus, Print } from '@mui/icons-material';
import {
    Alert,
    Backdrop,
    Button,
    CircularProgress,
    Dialog,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import { isEmpty, toNumber } from 'lodash';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import PropTypes from 'prop-types';
import MainCard from 'ui-component/cards/MainCard';
import AnimateButton from 'ui-component/extended/AnimateButton';
import DatePicker from '../UtilsComponent/BasicDate';
import useClassFee from './hooks/useClassFee';
import useTransportFee from './hooks/useTransportFee';
import * as yup from 'yup';
import useEssentialFee from './hooks/useEssentialFee';
// import './fees.css';

const validationSchema = yup.object({
    amount: yup.number().typeError('Must be a number type').min(0, 'Must be a positve number').required('Please enter fee amount'),
    mode: yup.string().required('Please select the payment mode').nullable(),
    transactionNo: yup.string().nullable(),
    date: yup.string().nullable(),
    updatedBy: yup.string().nullable()
});

const getTotalFees = (totalFees) => {
    if (totalFees) return toNumber(totalFees);
    return '';
};

const getMode = (mode) => {
    if (mode) return mode;
    return 'Cash';
};

const FeeStatusModal = ({ open, close, selectedBtn, handleFeeUpdate, feeType, selectedRecord, isFormDisabled, label = '' }) => {
    const location = useLocation();
    const { user } = useAuth();
    const [getFeeDeatails, updateFeeDetails, handleDueFees, responseData, isLoading, isFeeUpdated] = useClassFee();
    const [getTPFeeDeatails, updateTPFeeDetails, handleTPDueFees, responseTPData, isTPLoading, isTPFeeUpdated] = useTransportFee();
    const [getEFeeDeatails, updateEFeeDetails, handleEDueFees, responseEFData, isEFLoading, isEFUpdated] = useEssentialFee();

    const getSelectedMonthFeeDeatails = async () => {
        if (selectedRecord.id && feeType === 'class') {
            await getFeeDeatails(selectedBtn, selectedRecord.id);
        } else if (selectedRecord.id && feeType === 'trans') {
            await getTPFeeDeatails(selectedBtn, selectedRecord.id);
        } else if (selectedRecord.id && feeType === 'essen') {
            await getEFeeDeatails(selectedBtn, selectedRecord.id);
        }
    };

    useEffect(() => {
        if (open) {
            getSelectedMonthFeeDeatails();
        }
    }, [open]);

    const getIntialValue = (type) => {
        let initialValue;
        if (type === 'amount')
            if (feeType === 'class') {
                initialValue =
                    !isEmpty(responseData) && responseData.amount ? responseData.amount : getTotalFees(selectedRecord?.totalFees);
            } else if (feeType === 'trans') {
                initialValue =
                    !isEmpty(responseTPData) && responseTPData.amount ? responseTPData.amount : getTotalFees(selectedRecord?.transportFees);
            } else if (feeType === 'essen') {
                initialValue =
                    !isEmpty(responseEFData) && responseEFData.amount ? responseEFData.amount : getTotalFees(selectedRecord?.essentialFees);
            }

        if (type === 'mode')
            if (feeType === 'class') {
                initialValue = !isEmpty(responseData) ? getMode(responseData.mode) : 'Cash';
            } else if (feeType === 'trans') {
                initialValue = !isEmpty(responseTPData) ? getMode(responseTPData.mode) : 'Cash';
            } else if (feeType === 'essen') {
                initialValue = !isEmpty(responseEFData) ? getMode(responseEFData.mode) : 'Cash';
            }

        if (type === 'transactionNo')
            if (feeType === 'class') {
                initialValue = !isEmpty(responseData) ? responseData.transactionNo : '';
            } else if (feeType === 'trans') {
                initialValue = !isEmpty(responseTPData) ? responseTPData.transactionNo : '';
            } else if (feeType === 'essen') {
                initialValue = !isEmpty(responseEFData) ? responseEFData.transactionNo : '';
            }

        if (type === 'date')
            if (feeType === 'class') {
                initialValue = !isEmpty(responseData) && responseData.date ? responseData.date : format(new Date(), 'yyyy-MM-dd');
            } else if (feeType === 'trans') {
                initialValue = !isEmpty(responseTPData) && responseTPData.date ? responseTPData.date : format(new Date(), 'yyyy-MM-dd');
            } else if (feeType === 'essen') {
                initialValue = !isEmpty(responseEFData) && responseEFData.date ? responseEFData.date : format(new Date(), 'yyyy-MM-dd');
            }

        if (type === 'updatedBy')
            if (feeType === 'class') {
                initialValue = !isEmpty(responseData) ? responseData.updatedBy : '';
            } else if (feeType === 'trans') {
                initialValue = !isEmpty(responseTPData) ? responseTPData.updatedBy : '';
            } else if (feeType === 'essen') {
                initialValue = !isEmpty(responseEFData) ? responseEFData.updatedBy : '';
            }

        return initialValue;
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            amount: getIntialValue('amount'),
            mode: getIntialValue('mode'),
            transactionNo: getIntialValue('transactionNo'),
            date: getIntialValue('date'),
            updatedBy: getIntialValue('updatedBy')
        },
        validationSchema,
        onSubmit: (values) => {
            if (feeType === 'class') {
                updateFeeDetails(selectedBtn, selectedRecord.id, '', '', user.email, values, handleFeeUpdate);
            } else if (feeType === 'trans') {
                updateTPFeeDetails(selectedBtn, selectedRecord.id, '', '', user.email, values, handleFeeUpdate);
            } else if (feeType === 'essen') {
                updateEFeeDetails(selectedBtn, selectedRecord.id, '', '', user.email, values, handleFeeUpdate);
            }
        }
    });

    const handleMarkAsDue = (selectedBtn, studentId) => {
        if (feeType === 'class') {
            handleDueFees(selectedBtn, studentId, handleFeeUpdate);
        } else if (feeType === 'trans') {
            handleTPDueFees(selectedBtn, studentId, handleFeeUpdate);
        } else if (feeType === 'essen') {
            handleEDueFees(selectedBtn, studentId, handleFeeUpdate);
        }
    };

    return (
        <>
            {isLoading || isTPLoading || isEFLoading ? (
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading || isTPLoading || isEFLoading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            ) : (
                <Dialog
                    open={open && (!isEmpty(responseData) || !isEmpty(responseTPData) || !isEmpty(responseEFData))}
                    keepMounted
                    onClose={close}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    sx={{
                        '& .MuiDialog-paper': {
                            p: 0,
                            width: 300
                        }
                    }}
                >
                    {open && (
                        <Grid item xs={12} md={12} lg={12}>
                            {(isFeeUpdated || isTPFeeUpdated || isEFUpdated) && (
                                <Alert variant="filled" severity="success" sx={{ borderRadius: '4px 4px 0px 0px' }}>
                                    Fees successfully taken.
                                </Alert>
                            )}
                            <MainCard
                                title={
                                    <Stack direction="row" alignItems="center">
                                        {`${
                                            location.pathname !== '/vehicles/students' &&
                                            location.pathname !== '/tution-transport-fee/fee-details'
                                                ? selectedRecord?.rollNo
                                                : selectedRecord?.studentName
                                        } - ${feeType === 'essen' ? label : selectedBtn}`}{' '}
                                        {feeType === 'trans' ? <DirectionsBus /> : null}
                                    </Stack>
                                }
                                secondary={
                                    <IconButton sx={{ p: 0, pb: 0 }} onClick={close} size="large">
                                        <Close fontSize="small" />
                                    </IconButton>
                                }
                                sx={{
                                    '.MuiCardHeader-root': {
                                        p: 1.5
                                    },
                                    '.MuiCardContent-root': {
                                        p: 2
                                    },
                                    borderRadius: '0px 0px 4px 4px'
                                }}
                            >
                                <form onSubmit={formik.handleSubmit}>
                                    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Grid item xs={12}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                name="amount"
                                                value={formik.values.amount}
                                                onChange={formik.handleChange}
                                                error={formik.touched.amount && Boolean(formik.errors.amount)}
                                                helperText={formik.touched.amount && formik.errors.amount}
                                                fullWidth
                                                label="Amount"
                                                size="small"
                                                disabled={isFormDisabled}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel id="mode">Payment Mode</InputLabel>
                                                <Select
                                                    id="mode"
                                                    name="mode"
                                                    value={formik.values.mode}
                                                    onChange={formik.handleChange}
                                                    error={formik.touched.mode && Boolean(formik.errors.mode)}
                                                    fullWidth
                                                    label="Payment Mode"
                                                    size="small"
                                                    disabled={isFormDisabled}
                                                >
                                                    <MenuItem value="Cash">Cash</MenuItem>
                                                    <MenuItem value="Cheque">Cheque</MenuItem>
                                                    <MenuItem value="UPI">UPI</MenuItem>
                                                    <MenuItem value="Internet Banking">Internet Banking</MenuItem>
                                                </Select>
                                                <FormHelperText sx={{ color: 'red' }}>
                                                    {formik.touched.mode && formik.errors.mode}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                name="transactionNo"
                                                value={formik.values.transactionNo ? formik.values.transactionNo : ''}
                                                onChange={formik.handleChange}
                                                error={
                                                    formik.values.transactionNo && Boolean(formik.errors.transactionNo)
                                                        ? Boolean(formik.errors.transactionNo)
                                                        : false
                                                }
                                                helperText={
                                                    formik.touched.transactionNo && formik.errors.transactionNo
                                                        ? formik.errors.transactionNo
                                                        : ''
                                                }
                                                fullWidth
                                                label="Transaction No"
                                                size="small"
                                                disabled={formik.values.mode === 'Cash' || isFormDisabled}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <DatePicker
                                                id="date"
                                                name="date"
                                                value={formik.values.date}
                                                handleFormik={formik}
                                                error={formik.touched.date && Boolean(formik.errors.date)}
                                                helperText={formik.touched.date && formik.errors.date}
                                                fullWidth
                                                label="Date"
                                                size="small"
                                                disabled={isFormDisabled}
                                            />
                                        </Grid>
                                        {(responseData?.invoiceNo || responseTPData?.invoiceNo || responseEFData.invoiceNo) && (
                                            <>
                                                <Grid item xs={10} display="flex" alignItems="center">
                                                    <Typography style={{ fontSize: 11 }}>Invoice No -</Typography>
                                                    <Typography style={{ fontSize: 14, fontWeight: 600 }}>
                                                        &nbsp;
                                                        {responseData.invoiceNo || responseTPData?.invoiceNo || responseEFData.invoiceNo}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2} justifyContent="right" display="flex">
                                                    <IconButton disabled size="small" color="primary">
                                                        <Print />
                                                    </IconButton>
                                                </Grid>

                                                <Grid item xs={12} sx={{ pt: '4px !important' }} display="flex" alignItems="center">
                                                    <Typography style={{ fontSize: 11 }}>Taken By - </Typography>
                                                    <Typography style={{ fontSize: 14, fontWeight: 550 }}>
                                                        &nbsp;
                                                        {responseData?.updatedBy || responseTPData?.updatedBy || responseEFData.updatedBy
                                                            ? responseData?.updatedBy ||
                                                              responseTPData?.updatedBy ||
                                                              responseEFData.updatedBy
                                                            : ''}
                                                    </Typography>
                                                </Grid>
                                            </>
                                        )}

                                        {!isFormDisabled ? (
                                            <>
                                                <Grid item xs={6}>
                                                    <Stack direction="row" spacing={1} justifyContent="center">
                                                        <AnimateButton>
                                                            <Button variant="contained" type="submit" size="small">
                                                                Submit Fee
                                                            </Button>
                                                        </AnimateButton>
                                                    </Stack>
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <Stack direction="row" spacing={1} justifyContent="center">
                                                        <AnimateButton>
                                                            <Button
                                                                color="error"
                                                                variant="contained"
                                                                size="small"
                                                                onClick={() => handleMarkAsDue(selectedBtn, selectedRecord.id)}
                                                            >
                                                                Mark Due
                                                            </Button>
                                                        </AnimateButton>
                                                    </Stack>
                                                </Grid>
                                            </>
                                        ) : null}
                                    </Grid>
                                </form>
                            </MainCard>
                        </Grid>
                    )}
                </Dialog>
            )}
        </>
    );
};

FeeStatusModal.propTypes = {
    open: PropTypes.bool,
    close: PropTypes.func
};

export default FeeStatusModal;
